<script setup>
import {Head, Link} from "@inertiajs/vue3";

import GeneralLayout from "@/Layouts/GeneralLayout.vue";
import PracticeThisCTA from "@/Components/Marketing/PracticeThisCTA.vue";
import {BRAND_NAME, frequently_asked_questions} from "@/constants.js";

defineProps({
    questionSet: Object,
})
const introductionQuestions = [
    'May I know your full name?',
    'How may I address you?',
    'May I see your ID?',
    'Where do you come from?',
]
</script>

<template>
    <Head>
        <title>Sample IELTS Speaking Test #{{ questionSet.id }} - {{ questionSet.title }}</title>
        <meta name="description" :content="'Sample Speaking Test #' + questionSet.id + ' - ' + questionSet.title">
    </Head>
    <GeneralLayout>
        <template #header>
            <h1 class="max-w-6xl mx-auto px-2 py-6 text-4xl font-extrabold text-gray-900 dark:text-white">
                Question Set - {{ questionSet.title }}</h1>
        </template>

        <div class="max-w-6xl mx-auto sm:px-2 md:px-8">
            <section v-if="questionSet" class="py-4 bg-white dark:bg-gray-900">
                <PracticeThisCTA page-type="sample_exam" :item-id="questionSet.id" placement="top"/>

                <section class="p-2 lg:p-4 my-3 shadow-sm rounded-lg">
                    <h3 class="font-semibold text-lg dark:text-white text-primary-600">Part 1</h3>
                    <div>
                        <div class="text-xl font-semibold mb-4">Introduction Questions</div>

                        <div v-for="introductionQuestion in introductionQuestions"
                             class="py-2 px-4 bg-gray-100 rounded-md mb-2">
                            {{ introductionQuestion }}
                        </div>

                        <div v-if="questionSet.topic1" class="mt-6">
                            <h3 class="font-semibold text-medium dark:text-white text-primary-600 mb-3">Lets start with
                                {{ questionSet.topic1.title }}</h3>
                            <div v-for="question in questionSet.topic1.questions"
                                 class="py-2 px-4 bg-gray-100 rounded-md mb-2">
                                {{ question.question }}
                                <!-- answer -->
                                <div class="p-2 my-3 bg-gray-200">
                                    <span class="font-medium">Sample Answer:</span> {{ question.answer }}
                                </div>

                            </div>


                        </div>

                        <div v-if="questionSet.topic2" class="mt-6">
                            <h3 class="font-semibold text-medium dark:text-white text-primary-600 mb-3">Lets start with
                                {{ questionSet.topic2.title }}</h3>
                            <div v-for="question in questionSet.topic2.questions"
                                 class="py-2 px-4 bg-gray-100 rounded-md mb-2">
                                {{ question.question }}
                                <!-- answer -->
                                <div class="p-2 my-3 bg-gray-200">
                                    <span class="font-medium">Sample Answer:</span> {{ question.answer }}
                                </div>

                            </div>
                        </div>

                        <div v-if="questionSet.topic3" class="mt-6">
                            <h3 class="font-semibold text-medium dark:text-white text-primary-600 mb-3">Lets start with
                                {{ questionSet.topic3.title }}</h3>
                            <div v-for="question in questionSet.topic3.questions"
                                 class="py-2 px-4 bg-gray-100 rounded-md mb-2">
                                {{ question.question }}
                                <!-- answer -->
                                <div class="p-2 my-3 bg-gray-200">
                                    <span class="font-medium">Sample Answer:</span> {{ question.answer }}
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section v-if="questionSet.cue_card" class="p-2 lg:p-4 my-3 shadow-sm rounded-lg">
                    <h2 class="font-semibold text-lg dark:text-white text-primary-600 py-2">Part 2</h2>

                    <p class="mt-6 bg-primary-100 p-4 rounded-lg">
                        Now, I'm going to give you a topic and I'd like you to talk about it for 1-2 minutes.
                        Before you talk you'll have one minute to think about what you are going to say and you can
                        make notes if you wish. Do you understand?
                    </p>

                    <section class="bg-gray-300 p-6 mt-6 rounded-lg">
                        <p class="font-semibold">{{ questionSet.cue_card.title }}</p>
                        <div class="font-medium my-2">You should say:</div>
                        <ul class="list-disc pl-5">
                            <li v-for="subquestion in questionSet.cue_card.sub_questions" class="mb-1">
                                {{ subquestion }}
                            </li>
                        </ul>

                        <div class="p-2 my-3 bg-gray-200">
                            <div class="font-medium">Sample Answer:</div>
                            <ul>
                                <li v-for="line in questionSet.cue_card.answer">
                                    • {{ line }}
                                </li>
                            </ul>
                        </div>
                    </section>
                </section>

                <section v-if="questionSet.cue_card?.questions" class="p-2 lg:p-4 my-3 shadow-sm rounded-lg">
                    <h2 class="font-semibold text-lg dark:text-white text-primary-600 py-2">Part 3</h2>

                    <section class="mt-6">
                        <h3 class="font-semibold text-medium">
                            We've been talking about {{ questionSet.cue_card.title }}, and I'd now like to ask you
                            some questions related to this
                        </h3>
                        <ul class="list-disc pl-5 mt-3">
                            <li v-for="question in questionSet.cue_card.questions" class="mb-1">
                                {{ question.question }}
                                <div class="p-2 my-3 bg-gray-200">
                                    <span class="font-medium">Sample Answer:</span> {{ question.answer }}
                                </div>
                            </li>
                        </ul>
                    </section>
                </section>

                <PracticeThisCTA page-type="sample_exam" :item-id="questionSet.id" placement="bottom"/>
            </section>
        </div>
    </GeneralLayout>
</template>

<style scoped>

</style>
